import { ActionBase } from '../../../core/store/action/ActionBase';

export const EXPIRE_BROADCAST_ACTION = '[Configuration] Messages Expire Broadcast Action';

export class ExpireBroadcastAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = EXPIRE_BROADCAST_ACTION;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/messages/store/actions/ExpireBroadcastAction.ts